// Legacy e-clinicx base URL (port 8000) — only used by the commented-out
// sign-up / OTP / doctor endpoints below. Uncomment together with them.
// const BASE_URL = 'http://43.205.42.216:8000'

// Vehicle / cab APIs live on a different port (8001) than the rest of `main`
const VEHICLE_BASE_URL = 'http://43.205.42.216:8001'

// ================= Book a Vehicle =================
// Vehicle type ids drive the conditional cascade:
//   Passenger   -> Category -> Subcategory   (no facility)
//   Ambulance   -> Category -> Facility      (no subcategory)
//   Local Goods -> Category
export const PASSENGER_VEHICLE_TYPE_ID = 1
export const AMBULANCE_VEHICLE_TYPE_ID = 2
export const LOCAL_GOODS_VEHICLE_TYPE_ID = 3

export const VEHICLE_TYPE = `${VEHICLE_BASE_URL}/admin/vehicle-type/`
export const VEHICLE_CATEGORY = `${VEHICLE_BASE_URL}/vehicle-category/`
export const VEHICLE_SUBCATEGORY = `${VEHICLE_BASE_URL}/vehicles-subcategories/`
export const VEHICLE_NEARBY = `${VEHICLE_BASE_URL}/vehicles/nearby`
// NOTE: the images live in `banner_path` — an ARRAY of {name, path}, despite
// the singular field name — not `image` like every other list.
export const BANNER = `${VEHICLE_BASE_URL}/admin/banner/`
export const BANNER_TYPE_HOME = 'Home Page'

// Map falls back to this when we have no user location yet (Jaipur city centre)
export const DEFAULT_MAP_CENTER = { lat: 26.9124, lng: 75.7873 }
export const DEFAULT_RADIUS_KM = 50

// Legacy e-clinicx — user sign-up / sign-in / OTP screens are disabled
// export const SIGN_UP_USER = `${BASE_URL}/users/sign-up/`
// export const LOGIN_IN_OTP = `${BASE_URL}/users/login/otp/`
// export const OTP = `${BASE_URL}/security/get-otp/`

// Legacy e-clinicx — only used by the commented-out `doctor` API block
// export const DOCTOR = `${BASE_URL}/doctors/`
// export const DOCTOR_SLOT_LIST = `${BASE_URL}/doctors/doctor_slots/`
// export const BOOK_APPOINTMENT = `${BASE_URL}/doctors/appointments/`
